import { render, staticRenderFns } from "./Bingo.vue?vue&type=template&id=b853f21c&"
import script from "./Bingo.vue?vue&type=script&lang=js&"
export * from "./Bingo.vue?vue&type=script&lang=js&"
import style0 from "./Bingo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports